import React from "react";

import { MenuCardSkeleton } from "components/Shared/Skeletons";

type Props = {
  key: number;
};

export const DeliveryProductLoadingSkeleton: React.FC<Props> = ({ key }) => {
  return <MenuCardSkeleton key={key} className="elevation-low rounded" />;
};

export default DeliveryProductLoadingSkeleton;
